import QRCode from "qrcode";
import { PrizeShowInfo, RankingUser } from "../types";
import { generatePosterConfig } from "./poster-config";
import { FabricPosterGenerator } from "./fabric-poster";

// 生成邀请海报 - 使用Config + Fabric.js模式
export const generateInvitePoster = (userInfo: {
  avatar?: string;
  phoneNumber?: string;
  qrCodeUrl?: string;
  bgImageUrl?: string;
}): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    const startTime = performance.now();
    console.log('🚀 开始Config+Fabric.js海报生成，用户信息:', userInfo);

    let posterGenerator: FabricPosterGenerator | null = null;

    try {
      // 1. 生成海报配置（现在是异步的）
      const configStartTime = performance.now();
      const posterConfig = await generatePosterConfig(userInfo);
      const configDuration = performance.now() - configStartTime;
      console.log('⚙️ 海报配置生成完成，耗时:', configDuration.toFixed(2), 'ms');
      console.log('📋 配置详情:', {
        尺寸: `${posterConfig.width}x${posterConfig.height}`,
        元素数量: posterConfig.elements.length,
        背景色: posterConfig.backgroundColor
      });

      // 2. 创建Fabric.js生成器
      const generatorStartTime = performance.now();
      posterGenerator = new FabricPosterGenerator(posterConfig);
      const generatorCreateDuration = performance.now() - generatorStartTime;
      console.log('🏭 Fabric生成器创建完成，耗时:', generatorCreateDuration.toFixed(2), 'ms');

      // 3. 生成海报
      const renderStartTime = performance.now();
      const posterDataURL = await posterGenerator.generatePoster();
      const renderDuration = performance.now() - renderStartTime;

      // 4. 性能统计
      const totalDuration = performance.now() - startTime;
      console.log('✅ 海报生成成功，base64长度:', posterDataURL.length);
      console.log('📊 性能统计:');
      console.log('  - 配置生成:', configDuration.toFixed(2), 'ms');
      console.log('  - 生成器创建:', generatorCreateDuration.toFixed(2), 'ms');
      console.log('  - 渲染耗时:', renderDuration.toFixed(2), 'ms');
      console.log('  - 总耗时:', totalDuration.toFixed(2), 'ms');

      resolve(posterDataURL);
    } catch (error) {
      const errorTime = performance.now();
      const errorDuration = errorTime - startTime;
      console.error('❌ Config+Fabric.js海报生成失败:', error);
      console.error('⏱️ 失败前耗时:', errorDuration.toFixed(2), 'ms');
      reject(error);
    } finally {
      // 清理资源
      if (posterGenerator) {
        posterGenerator.dispose();
      }
    }
  });
};

// 获取用户对应的排名奖励
export const getUserRankingPrize = (user: RankingUser, rankingData: any): PrizeShowInfo | null => {
  if (!rankingData?.rankGradeList || rankingData.rankGradeList.length === 0) {
    return null;
  }

  // 如果用户有明确排名，按原逻辑处理
  if (user.cycleRanking !== null) {
    for (const grade of rankingData.rankGradeList) {
      // 检查排名是否落在当前档位区间内
      let isInRankRange = false;
      if (grade.maxRanking === null) {
        // maxRanking为null表示不限制最大排名，只要大于等于minRanking即可
        isInRankRange = user.cycleRanking >= grade.minRanking;
      } else {
        // 排名需要在minRanking和maxRanking之间
        isInRankRange = user.cycleRanking >= grade.minRanking && user.cycleRanking <= grade.maxRanking;
      }

      // 同时满足排名区间和成功数门槛条件
      if (isInRankRange && user.cycleSuccess >= grade.prizeThreshold) {
        return grade.prizeShowInfoList?.[0] || null;
      }
    }
  } else {
    // 用户排名为null时，检查是否有不限制最大排名的奖励
    if (user.cycleSuccess > 0) {
      for (const grade of rankingData.rankGradeList) {
        // 查找不限制最大排名的档位（maxRanking为null）
        if (grade.maxRanking === null && user.cycleSuccess >= grade.prizeThreshold) {
          return grade.prizeShowInfoList?.[0] || null;
        }
      }
    }
  }

  return null;
};


